import { setPassword } from 'Utils/Password';
import { UserFindById, UserChangePassword, UserChangeRole } from './Request';

const mapEmployee = (user, t2) => [
  user.payrollNum,
  user.fullName,
  user.Department.name,
  user.JobTitle.name,
  user.Terminal.name,
  user.status ? t2('Active') : t2('Inactive'), // as Text
  user.Role.name,
  user.entryDate,
  user.status, // as Boolean
  user.id,
  false,
];

export const fetchUser = async ({ id = '', t2 }) => {
  const userObject = await UserFindById({ id });

  const mappedObject = mapEmployee(userObject, t2);

  return mappedObject;
};

export const changePassword = async ({ oldPassword, newPassword, isAdmin, id }) => {
  const userResponse = await UserChangePassword({
    oldPassword,
    newPassword,
    isAdmin,
    userId: id,
  });

  if (userResponse?.transactionStatus && !isAdmin) {
    setPassword(newPassword);
  }

  return userResponse;
};

export const changeRole = async ({ userId, roleId }) => {
  const userResponse = await UserChangeRole({
    userId,
    roleId,
  });

  return userResponse;
};

export default { fetchUser, changePassword, changeRole };
